export const FETCH_APP_TOKEN_REQUEST = 'FETCH_APP_TOKEN_REQUEST'
export const FETCH_APP_TOKEN_SUCCESS = 'FETCH_APP_TOKEN_SUCCESS'
export const FETCH_APP_TOKEN_FAILURE = 'FETCH_APP_TOKEN_FAILURE'
export const CLEAR_APP_TOKEN = 'CLEAR_APP_TOKEN'



// WEBPACK FOOTER //
// ./src/constants/token.js